import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { init as initPlausible } from '@plausible-analytics/tracker'
import { router } from './router'
import { initializeDefaultConsent } from './components/common/CookieConsent'
import './i18n/config'
import './styles/index.css'

// Initialize Google Consent Mode v2 defaults BEFORE any analytics
initializeDefaultConsent()

// Initialize Plausible Analytics
const plausibleDomain = import.meta.env.VITE_PLAUSIBLE_DOMAIN || 'raisa.chat'
if (plausibleDomain) {
    initPlausible({
        domain: plausibleDomain,
        captureOnLocalhost: false,
    })
}

// Register Service Worker for PWA (on HTTPS only)
// Use build ID in URL so each deploy is seen as a new version and update modal can show
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
    const swUrl = `/sw.js?v=${typeof __SW_BUILD_ID__ !== 'undefined' ? __SW_BUILD_ID__ : Date.now()}`
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(swUrl)
            .then((registration) => {
                console.log('[PWA] Service Worker registered:', registration.scope)

                const checkUpdate = () => registration.update()

                // Check for updates when user comes back to tab (catches deploy while they were away)
                document.addEventListener('visibilitychange', () => {
                    if (document.visibilityState === 'visible') checkUpdate()
                })
                // Check periodically (every 5 min) and once after 10s on load
                setInterval(checkUpdate, 5 * 60 * 1000)
                setTimeout(checkUpdate, 10 * 1000)

                // Handle updates
                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing
                    if (newWorker) {
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                console.log('[PWA] New version available')
                                window.dispatchEvent(new CustomEvent('swUpdate', { detail: { worker: newWorker } }))
                            }
                        })
                    }
                })

                let refreshing = false
                navigator.serviceWorker.addEventListener('controllerchange', () => {
                    if (!refreshing) {
                        refreshing = true
                        window.location.reload()
                    }
                })
            })
            .catch((error) => {
                console.error('[PWA] Service Worker registration failed:', error)
            })
    })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>,
)
